<template>
  <div class="index">
    <div class="index-con">
      <div class="big-title">
        <span>Payment</span>
      </div>

      <div class="table en">
        <div class="list">
          <p>Items</p>
          <p>Registration Fee</p>
        </div>
        <div class="list">
          <p>Regular Registration</p>
          <p>400 USD/person</p>
        </div>
        <div class="list no-border">
          <p>Student Registration</p>
          <p>200 USD/person</p>
        </div>
      </div>



      <div class="table">

        <div class="list no-border">
          <div class="list-right">
            <div class="p-title"> Bank Account (US Dollar Remittance): </div>
            <div class="p"> Account Name: Jiangsu Chengxue Cultural Etiquette Service Co., Ltd. </div>
            <div class="p">Account Bank: Wuxi Lihu Branch of China Construction Bank Co., Ltd </div>
            <div class="p">Bank account number: 32050161894100001988 </div>
            <div class="p">SwiftCode: 105302000460 </div>
          </div>
        </div>
      </div>
      <div class="table">
        <div class="list">
          <div class="list-left">国内</div>
          <div class="list-right">
            <div class="p">在职人员：2300元/人</div>
            <div class="p">普通在校研究生：1200元/人</div>
          </div>
        </div>
        <div class="list no-border">
          <div class="list-left">国际</div>
          <div class="list-right">
            <div class="p">在职人员：400美元/人</div>
            <div class="p no-border">普通在校研究生：200美元/人</div>
          </div>
        </div>
      </div>
      <div class="table">
        <div class="list no-border">
          <div class="list-right">
            <div class="p-title">银行账户信息: </div>
            <div class="p">公司名称：江苏承学文化礼仪服务有限公司</div>
            <div class="p">开 户 行：中国建设银行股份有限公司无锡蠡湖支行</div>
            <div class="p">银行代码: 105302000460 </div>
            <div class="p">联系电话：13915265682</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {},
};
</script>

<style scoped lang="less">
.index-con {
  margin: 0 auto;
  width: 1200px;
}

.email {
  color: rgb(30, 98, 222);
  font-weight: 600;
}

.table {
  width: 800px;
  margin: 30px auto;
  border: 1px solid #28d6ec;

  .list {

    display: flex;
    box-sizing: border-box;
    border-bottom: 1px solid #28d6ec;
  }

  .list-left {
    width: 80px;
    border-right: 1px solid #28d6ec;
    display: flex;
    box-sizing: border-box;
    align-items: center;
    justify-content: center;
  }

  .list-right {
    flex: 1;
  }

  .p {
    flex: 1;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: left;
    box-sizing: border-box;
    margin-left: 30px;
  }

  .p-title {
    flex: 1;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: left;
    box-sizing: border-box;
    margin-left: 30px;
    font-weight: 700;
  }

  .no-border {
    border: 0;
  }
}

.en {
  .list {
    display: flex;
    height: 40px;
  }

  .list:nth-of-type(1) {
    font-weight: 600;
  }

  p {
    width: 50%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  p:nth-of-type(1) {
    border-right: 1px solid #28d6ec;
  }
}

.index-con {
  margin: 0 auto;
  width: 1200px;
  padding-bottom: 170px;
}

@media screen and (max-width: 768px) {
  .index-con {
    width: 100%;
  }

  .index {
    padding: 40px 10px 0;
    box-sizing: border-box;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pay.vue